import { Component, OnInit } from '@angular/core';
import { SELECTED_ACTIVE_CUSTOMERS_EULA_CONFIGS } from '@app-core/constants/constants';
import { EULA_CONFIG } from '@app-core/models/core.model';
import { AccessService } from '@app-core/services/access/access.service';
import { getClientConfig } from '@config/client-config';

@Component({
  selector: 'app-eula-document',
  templateUrl: './eula-document.component.html',
  styleUrls: ['./eula-document.component.scss'],
})
export class EulaDocumentComponent implements OnInit {
  public template: EULA_CONFIG['template'];
  private environment = getClientConfig().environments;

  constructor(private accessService: AccessService) {}

  ngOnInit(): void {
    this.decideWhichTemplateToShow();
  }

  private decideWhichTemplateToShow(): void {
    if (this.environment.isGeotabEnv) this.template = 'general';
    const customerName = this.accessService.getLoginInfo().customerName;
    this.template = SELECTED_ACTIVE_CUSTOMERS_EULA_CONFIGS[customerName].template;
  }
}
